export default angular.module('mun-doc', []);
